import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import * as icons from "@heroicons/react/solid";

import { CanViewTasks, CanEditUser, CanSeePortfolio } from "./pages/policy/permissions";
import { Link, Route } from "react-router-dom";
import { Role, roleToDisplayString } from "./internal_types";

import { Path } from "./routing/routing";
import React, { Suspense } from "react";
import { useLocalStorage } from "react-use";
import { Routes } from "./routing/routes";
import clsx from "clsx";
import { useGetCurrentUser, useTasksList } from "./dal/dal";
import { SelectorIcon } from "@heroicons/react/outline";
import { capitalize } from "./utils";
import { throwIfAppError } from "./utils/app_error";
import { AccordionButton } from "./components/AccordionButton";

const ArtificialLogo = () => {
  return (
    <svg width="93" height="18" viewBox="0 0 93 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0471 18V5.12262H16.1109V6.58957H16.1614C16.4099 6.10802 16.7797 5.72278 17.27 5.43386C17.759 5.14519 18.2948 5.00007 18.8758 5.00007C19.291 5.00007 19.6896 5.08116 20.0724 5.2415L19.5731 8.2738C19.2081 8.14626 18.8677 8.08145 18.5522 8.08145C17.0411 8.08145 16.2855 9.05267 16.2855 10.9949V18H13.0471ZM23.1214 13.4186V7.69802H21.0758V5.03211H23.1954V1.99994H26.264V5.03211H29.6066V7.69802H26.3143V13.1276C26.3143 13.8065 26.4309 14.2827 26.6637 14.5573C26.8962 14.8329 27.3701 14.9701 28.0855 14.9701H29.6066V17.9999H27.7859C26.0059 17.9999 24.7839 17.636 24.1194 16.9092C23.4535 16.1814 23.1214 15.0182 23.1214 13.4186ZM31.6139 18H34.6247V5.00007H31.6139V18ZM38.7191 17.9999V7.52191H36.632V4.81042H38.7191V3.08268C38.7191 1.96454 38.9638 1.1719 39.5474 0.702869C40.1301 0.234379 40.9801 0 42.0977 0H43.8858V2.83567H42.8588C42.4644 2.83567 42.1893 2.91361 42.0332 3.07005C41.8768 3.22621 41.7989 3.49365 41.7989 3.87183V4.81042H49.1772V17.9999H45.973V7.52191H41.8022V17.9999H38.7191ZM60.2176 12.4792L63.2278 13.1824C62.9869 14.7366 62.4056 15.9512 61.4258 16.7705C60.447 17.5905 59.2153 17.9999 57.7307 17.9999C55.9684 17.9999 54.5209 17.4053 53.3869 16.2158C52.2531 15.0272 51.6862 13.3719 51.6862 11.2495C51.6862 9.14441 52.2694 7.49294 53.4362 6.29592C54.602 5.09862 56.0423 4.49998 57.7555 4.49998C59.2076 4.49998 60.423 4.91798 61.4015 5.75343C62.3803 6.58889 62.9843 7.70572 63.2132 9.10445L60.2512 9.65908C59.9412 8.09996 59.1097 7.32012 57.7555 7.32012C56.8581 7.32012 56.144 7.65414 55.6139 8.32057C55.0838 8.9878 54.8184 9.96448 54.8184 11.2495C54.8184 12.5354 55.0788 13.5121 55.6014 14.1793C56.1237 14.8457 56.8418 15.18 57.7555 15.18C59.191 15.18 59.9404 14.2798 60.2176 12.4792ZM65.2351 18H68.246V5.00007H65.2351V18ZM83.3003 17.9999H86.813V0H83.3003V17.9999ZM68.7478 1.74999C68.7478 2.71628 67.9615 3.49998 66.9913 3.49998C66.0215 3.49998 65.2351 2.71628 65.2351 1.74999C65.2351 0.783704 66.0215 0 66.9913 0C67.9615 0 68.7478 0.783704 68.7478 1.74999ZM92.3329 16.2497C92.3329 17.216 91.5468 17.9997 90.5763 17.9997C89.6064 17.9997 88.8202 17.216 88.8202 16.2497C88.8202 15.2834 89.6064 14.4997 90.5763 14.4997C91.5468 14.4997 92.3329 15.2834 92.3329 16.2497ZM49.6789 1.74999C49.6789 2.71628 48.8926 3.49998 47.9225 3.49998C46.9526 3.49998 46.1663 2.71628 46.1663 1.74999C46.1663 0.783704 46.9526 0 47.9225 0C48.8926 0 49.6789 0.783704 49.6789 1.74999ZM35.1265 1.74999C35.1265 2.71628 34.3402 3.49998 33.3701 3.49998C32.4002 3.49998 31.6139 2.71628 31.6139 1.74999C31.6139 0.783704 32.4002 0 33.3701 0C34.3402 0 35.1265 0.783704 35.1265 1.74999ZM75.6225 12.4074C74.8347 12.6002 74.3189 12.8292 74.0749 13.0944C73.8306 13.3595 73.7089 13.6609 73.7089 13.9984C73.7089 14.8663 74.3231 15.3002 75.5516 15.3002C76.4808 15.3002 77.1778 15.1193 77.6428 14.7577C78.1073 14.3962 78.3399 13.9504 78.3399 13.4198V11.202C78.3399 11.202 78.2253 11.3908 78.0917 11.5031C78.0141 11.5685 77.7802 11.6962 77.3708 11.865C76.9611 12.0337 76.3786 12.2144 75.6225 12.4074ZM78.7175 17.9999V16.4086H78.6704C78.6387 16.457 78.5995 16.5175 78.5521 16.5896C78.505 16.6619 78.3867 16.7867 78.1978 16.9633C78.0091 17.1404 77.7963 17.3008 77.56 17.4455C77.3236 17.59 77.0005 17.7185 76.5911 17.8311C76.1814 17.9435 75.7405 17.9999 75.2681 17.9999C73.7559 17.9999 72.6256 17.6346 71.8777 16.9031C71.129 16.1718 70.7551 15.2759 70.7551 14.215C70.7551 13.1062 71.0779 12.2624 71.7242 11.6837C72.3697 11.1053 73.4643 10.6231 75.0082 10.2375C76.4413 9.88402 77.339 9.60265 77.7015 9.39365C78.0638 9.18492 78.2451 8.88735 78.2451 8.50175C78.2451 8.11589 78.0678 7.79456 77.7134 7.53722C77.3591 7.28043 76.8277 7.15163 76.1187 7.15163C75.2837 7.15163 74.6851 7.34064 74.3231 7.71814C73.9605 8.09591 73.6768 8.60652 73.4725 9.24918L70.9208 8.16395C71.2195 7.08763 71.8026 6.20762 72.669 5.52445C73.5352 4.84129 74.6692 4.49998 76.0713 4.49998C77.5991 4.49998 78.8512 4.9096 79.8282 5.7294C80.8045 6.54893 81.2931 7.81886 81.2931 9.53811V17.9999H78.7175ZM4.86748 12.4074C4.07934 12.6002 3.5638 12.8292 3.31978 13.0944C3.07551 13.3595 2.95377 13.6609 2.95377 13.9984C2.95377 14.8663 3.56776 15.3002 4.79629 15.3002C5.72575 15.3002 6.42285 15.1193 6.88758 14.7577C7.35205 14.3962 7.58468 13.9504 7.58468 13.4198V11.202C7.58468 11.202 7.47009 11.3908 7.33644 11.5031C7.25916 11.5685 7.0252 11.6962 6.61578 11.865C6.2061 12.0337 5.62333 12.2144 4.86748 12.4074ZM7.96264 17.9999V16.4086H7.91553C7.88351 16.457 7.84434 16.5175 7.79723 16.5896C7.75012 16.6619 7.63182 16.7867 7.44286 16.9633C7.2539 17.1404 7.04112 17.3008 6.80478 17.4455C6.56871 17.59 6.24557 17.7185 5.83615 17.8311C5.4262 17.9435 4.98555 17.9999 4.51288 17.9999C3.00065 17.9999 1.87031 17.6346 1.1224 16.9031C0.373956 16.1718 0 15.2759 0 14.215C0 13.1062 0.322613 12.2624 0.968898 11.6837C1.61465 11.1053 2.70926 10.6231 4.25325 10.2375C5.68635 9.88402 6.58406 9.60265 6.94637 9.39365C7.30895 9.18492 7.48997 8.88735 7.48997 8.50175C7.48997 8.11589 7.31265 7.79456 6.95828 7.53722C6.60417 7.28043 6.07248 7.15163 5.36348 7.15163C4.52849 7.15163 3.93011 7.34064 3.5678 7.71814C3.20549 8.09591 2.92178 8.60652 2.7172 9.24918L0.165409 8.16395C0.464468 7.08763 1.0475 6.20762 1.91398 5.52445C2.77992 4.84129 3.91397 4.49998 5.31637 4.49998C6.84421 4.49998 8.09629 4.9096 9.07339 5.7294C10.0497 6.54893 10.538 7.81886 10.538 9.53811V17.9999H7.96264Z"
        fill="black"
      />
    </svg>
  );
};

export const Sidebar = () => {
  const user = useGetCurrentUser();

  if (user.status === "error") {
    throw user;
  }

  const [isOpen_, setIsOpen] = useLocalStorage<boolean>("header/is-open", true);
  const isOpen = isOpen_ ? true : false;
  const canEditUsers = CanEditUser({ currentRole: user.value.role }).check(undefined);
  const canViewTasks = CanViewTasks({ currentRole: user.value.role }).check(undefined);
  const canSeePortfolio = CanSeePortfolio({ currentRole: user.value.role }).check(undefined);

  return (
    <div
      className={clsx([
        "bg-gray-100",
        "border-r",
        "flex",
        "flex-col",
        "flex-none",
        "justify-center",
        isOpen ? "w-48" : "w-16",
      ])}
    >
      <div
        className={clsx([
          "text-2xl",
          "font-bold",
          isOpen && "px-6",
          "py-7",
          "flex",
          "flex-row",
          "justify-between",
        ])}
      >
        {isOpen && <ArtificialLogo />}
        <OpenSidebarIcon isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
      </div>

      <nav className="flex-1">
        <NavItem
          isOpen={isOpen}
          to={Routes.policies.generateRouterString()}
          icon={icons.InboxInIcon}
          exactMatch
        >
          Inbox
        </NavItem>
        {canSeePortfolio && (
          <NavItem
            isOpen={isOpen}
            to={Routes.portfolio.generateRouterString()}
            icon={icons.ChartPieIcon}
            exactMatch={false}
          >
            Portfolio
          </NavItem>
        )}
        <NavItem
          isOpen={isOpen}
          to={Routes.products.generateRouterString()}
          icon={icons.CollectionIcon}
        >
          Products
        </NavItem>
        {canEditUsers && (
          <NavItem isOpen={isOpen} to={Routes.users.generateRouterString()} icon={icons.UsersIcon}>
            Users
          </NavItem>
        )}
        {canViewTasks && <TaskAccordionButton isOpen={isOpen} />}
      </nav>
      <div>
        <CurrentUserMenu isOpen={isOpen} />
      </div>
    </div>
  );
};

function NavItem(props: {
  to: Path | string;
  icon: React.FC<React.ComponentProps<"svg">>;
  children: React.ReactNode;
  isOpen: boolean;
  exactMatch?: boolean;
}) {
  return (
    <Route
      exact={props.exactMatch}
      path={typeof props.to === "string" ? props.to : props.to.pathname}
      children={({ match }) => {
        return (
          <Link
            to={props.to}
            className={clsx(
              "py-2.5 font-medium flex gap-3 group cursor-pointer items-center select-none",
              props.isOpen ? "px-5 " : "px-5",
              match !== null ? "bg-gray-200" : "hover:bg-gray-200",
            )}
          >
            {React.createElement(props.icon, {
              className: clsx(
                "h-5 w-5",
                match !== null && match.isExact ? "text-gray-900" : "text-gray-400 ",
              ),
            })}
            {props.isOpen && props.children}
          </Link>
        );
      }}
    />
  );
}

const CurrentUserMenu: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
  const user = useGetCurrentUser();

  if (user.status === "error") {
    throw user;
  }

  const signOut = async () => {
    await aws_amplify.Auth.signOut().then(() => {
      location.reload();
    });
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className="outline-none text-left hover:bg-gray-200 px-2 py-1 w-full cursor-pointer">
        <div className="flex items-center">
          {isOpen && (
            <div className="shrink overflow-hidden">
              <div className="px-4 pt-4 font-medium truncate">{user.value.displayName}</div>
              <div className="px-4 pb-6 text-gray-600">{capitalize(user.value.role)}</div>
            </div>
          )}
          <div className={clsx(!isOpen && "m-auto py-6")}>
            <SelectorIcon className="h-6 w-6 text-gray-500" />
          </div>
        </div>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content align="start" className="w-44 rounded shadow-lg py-1 ml-2 bg-white">
        <DropdownMenu.Item
          onSelect={signOut}
          className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 outline-none select-none"
        >
          Log out
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export function UserRoleBadge(props: { role: Role }): JSX.Element {
  const displayName = roleToDisplayString(props.role);
  switch (props.role) {
    case "underwriter":
      return (
        <div className="inline-block bg-red-600 text-white rounded-full px-2 leading-loose font-medium">
          {displayName}
        </div>
      );
    case "broker":
      return (
        <div className="inline-block bg-blue-600 text-white rounded-full px-2 leading-loose font-medium">
          {displayName}G
        </div>
      );
    case "admin":
      return (
        <div className="inline-block bg-green-600 text-white rounded-full px-2 leading-loose font-medium">
          {displayName}
        </div>
      );
    case "read_only":
      return (
        <div className="inline-block bg-gray-400 text-white rounded-full px-2 leading-loose font-medium">
          {displayName}
        </div>
      );
  }
}

const OpenSidebarIcon: React.FC<{ isOpen: boolean; onClick: () => void }> = ({
  isOpen,
  onClick,
}) => {
  return (
    <a onClick={onClick} className={clsx("flex cursor-pointer", !isOpen && "px-5")}>
      {isOpen && (
        <svg className="h-5 w-0.5 grey-900">
          <line x1="0" y1="5.5" x2="0" y2="14.5" stroke="black" strokeWidth="4" />
        </svg>
      )}
      {isOpen && <icons.ArrowNarrowLeftIcon className="h-5 w-5 grey-900" />}
      {!isOpen && <icons.ArrowNarrowRightIcon className="h-5 w-5 grey-900" />}
      {!isOpen && (
        <svg className="h-5 w-1 grey-900">
          <line x1="0" y1="5" x2="0" y2="15" stroke="black" strokeWidth="3" />
        </svg>
      )}
    </a>
  );
};

const subentries = [
  ["Queued", "in_queue"],
  ["In progress", "in_progress"],
  ["Completed", "succeeded"],
  ["Failed", "failed"],
] as const;

const LoadingTaskAccordionButton = (props: { isOpen: boolean }) => {
  const subentriesResults: [string, number][] = subentries.map(([title, filter]) => {
    const result = useTasksList({ filter, countOnly: true }, 10 * 1000);
    throwIfAppError(result);
    return [title, result.value.count];
  });

  const route = Routes.tasks.generatePath({});
  return (
    <Route
      exact={true}
      path={route.pathname}
      children={({ match }) => {
        return (
          <AccordionButton
            isOpen={props.isOpen}
            selected={match !== null}
            to={Routes.tasks.generatePath({})}
            mainEntry={{
              title: "Tasks",
              count: subentriesResults.reduce((acc, [_, count]) => count + acc, 0),
            }}
            subentries={subentriesResults.map(([title, count]) => ({
              title,
              count,
            }))}
          />
        );
      }}
    />
  );
};

const FallbackTaskAccordionButton = (props: { isOpen: boolean }) => {
  return (
    <AccordionButton
      isOpen={props.isOpen}
      selected={false}
      to={Routes.tasks.generatePath({})}
      mainEntry={{
        title: "Tasks",
        count: 0,
      }}
      subentries={subentries.map(([title, _]) => ({
        title,
        count: 0,
      }))}
    />
  );
};

const TaskAccordionButton = (props: { isOpen: boolean }) => {
  return (
    <Suspense fallback={<FallbackTaskAccordionButton isOpen={props.isOpen} />}>
      <LoadingTaskAccordionButton isOpen={props.isOpen} />
    </Suspense>
  );
};
